export default "__VITE_PUBLIC_ASSET__bf807de8__"